const BalanceFooter = ({ amount }) => {
  const isNegative = String(amount).includes("-");

  return (
    <div className="flex justify-between items-center text-sm pt-2 border-t">
      <span className="text-gray-600">Balance amount</span>

      <span
        className={`font-medium ${
          isNegative ? "text-red-600" : "text-green-600"
        }`}
      >
        {amount}
      </span>
    </div>
  );
};

export default BalanceFooter;
